import { InvestmentTransactionType } from "hooks/investments/GetInvestmentTransactionsHook";
import { TYPE_LABELS, formatNumber, DotsMenu } from "./tableUtils";

interface PreciousMetalsTableProps {
  transactions: InvestmentTransactionType[];
  item: any | null;
  isOwn?: boolean;
  onEditTx?: (tx: InvestmentTransactionType) => void;
}

const PreciousMetalsTable = ({
  transactions,
  item,
  isOwn = false,
  onEditTx,
}: PreciousMetalsTableProps) => {
  return (
    <table className="itm-table">
      <thead>
        <tr>
          <th>Transakcja</th>
          <th>Cena zakupu</th>
          <th>Waluta</th>
          <th>Masa</th>
          <th>Próba</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        {transactions.map((tx) => (
          <tr key={tx.uuid}>
            <td>{TYPE_LABELS[tx.type] ?? tx.type}</td>
            <td>{formatNumber(tx.totalValue)}</td>
            <td>{tx.currency?.short ?? "Brak"}</td>
            <td>
              {tx.quantity != null
                ? `${tx.type === "buy" ? "+" : "-"}${tx.quantity}g`
                : "Brak"}
            </td>
            <td>{item?.details?.finess ?? "Brak"}</td>

            <td>
              <DotsMenu
                tx={tx}
                onEdit={
                  isOwn || tx.type === "sell" ? () => onEditTx?.(tx) : undefined
                }
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PreciousMetalsTable;
